<template>
	<div class="footer-style-wrap">
		<div class="section-header">设置</div>
		<div class="el-row"> <span>网站版权：</span> <el-input v-model="t_data.copyright" placeholder=""></el-input></div>
		<div class="el-row">
			<span> 许可编号： </span> <el-input v-model="t_data.license"  placeholder="请输入许可号..."></el-input>
		</div>
		<div class="el-row">
			<span>客服电话：</span> <el-input v-model="t_data.phone"  placeholder="请输入客服电话..."></el-input>
		</div>
		<div class="el-row">
			<span>服务时间：</span> <el-input v-model="t_data.time"  placeholder="请输入客服电话服务时间..."></el-input>
		</div>
	</div>
</template>
<script>
export default {
  props: ['info'],
  data () {
    return {
      t_data: this.info
    }
  },
  watch: {
    // t_data: {
    //   handler (newVal, oldVal) {
    //     console.log('inner watch', newVal)
    //     this.$emit('update:info', newVal)
    //   },
    //   deep: true,
    //   immediate: true
    // }
  }
}
</script>
<style lang="scss" scoped>
.footer-style-wrap{
	span{
		
	}
}
</style>

<style lang="scss" >
.footer-style-wrap{
	.el-input{
		width:80%;
	}
}
</style>




// WEBPACK FOOTER //
// style.vue?987b9b4e